module.exports = __webpack_public_path__ + "static/media/jumbled-words.ff5e0f71.svg";